
<div class="padding-20 ui-g" id="c3_searchProducts_Modal">
 
  <app-campaign-3-kontable 
  *ngIf="show.table"
  id="productsListTable"            
  [columns] = "[         
  { field: 'code', title: 'campaign.code' },
  { field: 'description', title: 'campaign.description' },
  { field: 'product_categories', title: 'campaign.category' },
  { field: 'product_department', title: 'campaign.department' },
  { field: 'barcode', title: 'campaign.barcode' }
]"
     
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="false"
  [service]="srvCampaign3"
  [fixedFilters]="filters"
  [methodsNames]="{ list: 'getProductItemComplete', sendExtSearchQuery: 'sendExtSearchQuery' }"
  [showSelectButton]="false"
  #productsListTable>


</app-campaign-3-kontable>  
  
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/view-products/campaign-3-view-products.component.html